import { render, staticRenderFns } from "./tableImportStudent.vue?vue&type=template&id=01f2f40e&scoped=true"
import script from "./tableImportStudent.vue?vue&type=script&lang=js"
export * from "./tableImportStudent.vue?vue&type=script&lang=js"
import style0 from "./tableImportStudent.vue?vue&type=style&index=0&id=01f2f40e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f2f40e",
  null
  
)

export default component.exports